import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import useHttp from "../../../../hook/use-http";
import { API_URL_MAIN } from "../../../../constants/driveglobalfilterinitalstates_bus";
import VinRegChart from './VinRegChart';
import moment from 'moment';
import ChartLoader_Bus from '../ChartLoader_Bus';
import NoDataDischargeCity from '../NoData/NoDataDischargeCity';
import { BsFillArrowLeftSquareFill } from "react-icons/bs";
import ChartDataLabels from 'chartjs-plugin-datalabels';
// ChartJS.register(ChartDataLabels);
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default function DepoRegChart(props) {

  const { isLoading, error, sendReq: fetchData } = useHttp();
  let { gloablfilter } = props.gloablfilter;

  let apiprops = props.apiprops;
  apiprops.city = props.clickedIndex;
  let monthLabel = props.monthLabel

  const [clickedIndex, setClickedIndex] = useState(null);
  const [depoLabel, setDepoLabel] = useState([]);
  const [monthLegends, setMonthLegends] = useState([]);
  const [depoData, setDepoData] = useState([]);
  const [duration, setDuration] = useState(props.duration);
  const [sDate, setSDate] = useState("");
  const [eDate, setEDate] = useState("");
  const [TitleSelected, setTitleSelected] = useState('En_Reg');
  const [distSelected, setDistSelected] = useState(props.distSelected);

  const handleDurationSelection = async (durationValue) => {
    await updateDates(durationValue);
  }

  const updateDates = async (durationValue) => {
    setDuration(durationValue);
    if (durationValue === "7D") {
      setEDate(moment().format('YYYY-MM-DD'));
      setSDate(moment().subtract(7, 'days').format('YYYY-MM-DD'));
    } else if (durationValue === '1M') {
      setEDate(moment().format('YYYY-MM-DD'));
      setSDate(moment().subtract(31, 'days').format('YYYY-MM-DD'));
    } else if (durationValue === '3M') {
      setEDate(moment().format(('YYYY-MM-DD')));
      setSDate(moment().subtract(91, 'days').format('YYYY-MM-DD'));
    } else if (durationValue === '6M') {
      setEDate(moment().format('YYYY-MM-DD'));
      setSDate(moment().subtract(183, 'days').format('YYYY-MM-DD'));
    } else if (durationValue === '1Y') {
      setEDate(moment().format('YYYY-MM-DD'));
      setSDate(moment().subtract(366, 'days').format('YYYY-MM-DD'));
    }
  }

  useEffect(() => {
    if (props.duration === "7D") {
      setEDate(moment().format('YYYY-MM-DD'));
      setSDate(moment().subtract(7, 'days').format('YYYY-MM-DD'));
    } else if (props.duration === '1M') {
      setEDate(moment().format('YYYY-MM-DD'));
      setSDate(moment().subtract(31, 'days').format('YYYY-MM-DD'));
    } else if (props.duration === '3M') {
      setEDate(moment().format(('YYYY-MM-DD')));
      setSDate(moment().subtract(91, 'days').format('YYYY-MM-DD'));
    } else if (props.duration === '6M') {
      setEDate(moment().format('YYYY-MM-DD'));
      setSDate(moment().subtract(183, 'days').format('YYYY-MM-DD'));
    } else if (props.duration === '1Y') {
      setEDate(moment().format('YYYY-MM-DD'));
      setSDate(moment().subtract(366, 'days').format('YYYY-MM-DD'));
    }
  }, [props, apiprops]);

  useEffect(() => {
    if (sDate !== "" && eDate !== "") {
      if (distSelected === 'NetkWh') {
        fetchData(
          {
            url: API_URL_MAIN + "trend_analysis_drive_bus/depoWiseRegTrend",
            body: {
              filterdata: {
                "CITY": [apiprops.city],
                "DEPO": apiprops.depo,
                "LOB": [],
                "PL": [],
                "PPL": [],
                "SOC": 0,
                "VIN_NUM": [],
                "endDate": eDate,
                // "endDate": "2023-10-22",
                "pageSelected": 1,
                "startDate": sDate,
                // "startDate": "2023-10-15",
                "AIR_VENTILATION": "",
                "duration": duration
              }
            },
          },
          responceDataDate
        );
      } else {
        fetchData(
          {
            url: API_URL_MAIN + "trend_analysis_drive_bus/depoWiseRegPerKmTrend",
            body: {
              filterdata: {
                "CITY": [apiprops.city],
                "DEPO": apiprops.depo,
                "LOB": [],
                "PL": [],
                "PPL": [],
                "SOC": 0,
                "VIN_NUM": [],
                "endDate": eDate,
                // "endDate": "2023-10-22",
                "pageSelected": 1,
                "startDate": sDate,
                // "startDate": "2023-10-15",
                "AIR_VENTILATION": "",
                "duration": duration
              }
            },
          },
          responceDataDate
        );
      }
    }
  }, [sDate, eDate, distSelected, duration]);

  const responceDataDate = (data) => {
    setDepoLabel(data.depots)
    setMonthLegends(data.monthNames)
    setDepoData(Object.values(data.nestedList))
    // if(distSelected === "NetkWh"){
    //     setDepoData(Object.values(data.nestedList))
    // }else{
    //     setDepoData(Object.values(data.nestedListPerKm))
    // }
  }

  const colorPalette = ['#02559b', '#83a3ce', '#ced9e9', '#6081AA', '#3D6087', '#D4DFEB', '#184165', '#002446', '#1E618E', '#53749D', '#AFCFFC', '#949BE6',];

  const labels = monthLegends

  let datasets = [];

  if (depoLabel && depoLabel.length > 0) {
    datasets = depoLabel.map((label, index) => ({
      label,
      data: index < depoData.length ? depoData[index] : [],
      backgroundColor: colorPalette[index % colorPalette.length],
    }));
  }

  const data = {
    labels,
    datasets: datasets
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        // position: 'top' as const,
      },

      title: {
        display: true,
      },
      datalabels: {
        color: '#fff', // color of the data labels
        anchor: 'end', // position of the data labels
        align: 'start', // alignment of the data labels
        rotation: 270,
        font: {
          weight: 'bold', // make the text bold
        },
        formatter: function (value, context) {
          return Number(value).toFixed(3); // format how the data labels appear
        }
      },
    },
    scales: {
      x: {
        grid: {
          display: false, // hide x-axis grid lines
        },
      },
      y: {
        grid: {
          display: false, // hide y-axis grid lines
        },
      },
    },
    onClick: (event, elements) => handleBarClick(event, elements),
    elements: {
      bar: {
        borderColor: '#494F55', // Set border color for bars
        borderWidth: 1, // Set border width for bars
      },
    },
  };

  const handleBarClick = (event, elements) => {
    if (elements.length > 0) {
      const barIndex = elements[0].index;
      const datasetIndex = elements[0].datasetIndex;
      const clickedDepo = depoLabel[datasetIndex]; // Get the city associated with the clicked dataset
      const clickedMonth = monthLegends[barIndex]; // Get the month ID associated with the clicked bar
      apiprops.DEPO = clickedDepo
      setClickedIndex(clickedDepo)
    }
  };

  const handleBackDetails = (e) => {
    props.onreset(props.gloablfilter, duration);
  };

  const resetfunc = (gb, dur) => {
    apiprops.depo = gb.DEPO
    handleDurationSelection(dur)
    setClickedIndex(null);
  }

  const changeTitle = (selectTitle) => {
    setTitleSelected(selectTitle);
    props.onreset(selectTitle)
  }

  const changedistTrigger = (topup) => {
    setDistSelected(topup)
  }

  return (
    <div>
      <div className={clickedIndex === null ? 'row mt-0 mb-2 discharge_titlebg_bus_trend' : 'row d-none mt-0 mb-2 discharge_titlebg_bus_trend'}>
        <div className='col-md-1 pt-2'><BsFillArrowLeftSquareFill onClick={handleBackDetails} style={{ fontWeight: "bold", color: "#02559b", cursor: "pointer", fontSize: "2em" }} /></div>
        <div className="col-md-4 ">
          <div className="text-fit">Regeneration Analysis</div>
        </div>

        {/* <div className={TitleSelected === 'SOC' ? "col-md-7" : "col-md-4"}>
          <div className="text-fit">
            <select className="form-select form-select-sm" aria-label=".form-select-sm example" style={{ marginBottom: "-5px", marginTop: "-5px" }} onChange={(event) => changeTitle(event.target.value)} value={TitleSelected}>
              <option value="SOC">Disc. Soc(%) Analysis</option>
              <option value="En_Reg">Reg. Analysis</option>
            </select>
          </div>
        </div> */}

        <div className="col-md-5 py-1">
          <div className="mt-1" style={{ border: "1px solid #b7c0ca", padding: "3px", borderRadius: "5px", float: "right" }}>
            <ul className="nav nav-tabs" role="tablist" style={{ marginBottom: "5px", border: "0px" }}>
              <li className="nav-item" style={{ width: "40px" }}>
                <a
                  style={{ justifyContent: "center", backgroundColor: duration === "7D" ? "#f2f2f2" : "transparent", color: duration === "7D" ? "#fff" : "#000" }}
                  className={(duration === "7D") ? "nav-link active py-0" : "nav-link py-0"}
                  data-bs-toggle="tab"
                  href="#day"
                  id="7D"
                  onClick={() => handleDurationSelection("7D")}
                >
                  7D
                </a>
              </li>
              <li className="nav-item" style={{ width: "40px" }}>
                <a
                  style={{ justifyContent: "center", backgroundColor: duration === "1M" ? "#f2f2f2" : "transparent", color: duration === "1M" ? "#fff" : "#000" }}
                  className={(duration === "1M") ? "nav-link active py-0" : "nav-link py-0"}
                  data-bs-toggle="tab"
                  href="#mon"
                  onClick={() => handleDurationSelection("1M")}
                >
                  1M
                </a>
              </li>
              <li className="nav-item" style={{ width: "40px" }}>
                <a
                  style={{ justifyContent: "center", backgroundColor: duration === "3M" ? "#f2f2f2" : "transparent", color: duration === "3M" ? "#fff" : "#000" }}
                  className={(duration === "3M") ? "nav-link active py-0" : "nav-link py-0"}
                  data-bs-toggle="tab"
                  href="#mon"
                  onClick={() => handleDurationSelection("3M")}
                >
                  3M
                </a>
              </li>
              <li className="nav-item" style={{ width: "40px" }}>
                <a
                  style={{ justifyContent: "center", backgroundColor: duration === "6M" ? "#f2f2f2" : "transparent", color: duration === "6M" ? "#fff" : "#000" }}
                  className={(duration === "6M") ? "nav-link active py-0" : "nav-link py-0"}
                  data-bs-toggle="tab"
                  href="#mon"
                  onClick={() => handleDurationSelection("6M")}
                >
                  6M
                </a>
              </li>
              <li className="nav-item" style={{ width: "40px" }}>
                <a
                  style={{ justifyContent: "center", backgroundColor: duration === "1Y" ? "#f2f2f2" : "transparent", color: duration === "1Y" ? "#fff" : "#000" }}
                  className={(duration === "1Y") ? "nav-link active py-0" : "nav-link py-0"}
                  data-bs-toggle="tab"
                  href="#year"
                  onClick={() => handleDurationSelection("1Y")}
                >
                  1Y
                </a>
              </li>
            </ul>
          </div>
        </div>

        {(TitleSelected === "En_Reg") &&
          <div className='col-md-2 py-2'>
            <select
              className="form-select form-select-sm"
              aria-label="Default select example"
              onChange={(event) => changedistTrigger(event.target.value)}
              value={distSelected}
            >
              <option value="NetkWh">kWh</option>
              <option value="whPerKM">kWh/km</option>
            </select>
          </div>
        }

      </div>
      {(clickedIndex !== null) ? <VinRegChart gloablfilter={props.gloablfilter} apiprops={apiprops} clickedIndex={clickedIndex} monthLabel={monthLabel} duration={duration} onreset={resetfunc} distSelected={distSelected} />
        :
        (isLoading) ? <ChartLoader_Bus /> :
          (depoData.length === 0) ? <NoDataDischargeCity /> :
            (
              <Bar data={data} options={options} type={'bar'} height={(window.innerWidth > 768) ? 126 : 300} width="auto" paddingTop="0px" plugins={[ChartDataLabels]} />
            )
      }
    </div>
  )
}
